import { render } from "./MyBenefitCalendar.vue?vue&type=template&id=27dc5818"
import script from "./MyBenefitCalendar.vue?vue&type=script&lang=js"
export * from "./MyBenefitCalendar.vue?vue&type=script&lang=js"

import "./MyBenefitCalendar.vue?vue&type=style&index=0&id=27dc5818&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__